import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useUserData } from '../../../../../hooks'
import { DragDropProvider } from '../../../../DragDrop'
import { EmailRecipientsField } from '../../../../Email'
import { FormikField } from '../../../../Formik'
import { APPOINTMENT_FORM_FIELD_NAME } from '../../AppointmentFormModal.constants'
import {
  getAppointmentFormOrganizerChips,
  getHasAppointmentFormDuplicateParticipant,
  getIsAppointmentFormParticipantInputDuplicate,
} from '../../AppointmentFormModal.utils.participants'

import { AppointmentFormModalParticipantTag } from './AppointmentFormModalParticipantTag'

function AppointmentFormModalParticipantsField() {
  const { t } = useTranslation()

  const userData = useUserData()

  const { setFieldError, values } = useFormikContext()

  const organizerChips = getAppointmentFormOrganizerChips({ t, userData })

  const participants = values[APPOINTMENT_FORM_FIELD_NAME.participants]

  function setDuplicateError(isDuplicate) {
    setFieldError(
      APPOINTMENT_FORM_FIELD_NAME.participants,
      isDuplicate ? t('Appointment.FormDuplicateParticipantKey') : undefined
    )
  }

  function getIsDuplicate(nextParticipants) {
    return getHasAppointmentFormDuplicateParticipant([
      ...organizerChips,
      ...nextParticipants,
    ])
  }

  // A duplicate keeps the chips as they were (BR-CAL-02-08)
  function getNextParticipants(nextParticipants, currentParticipants) {
    return getIsDuplicate(nextParticipants)
      ? currentParticipants
      : nextParticipants
  }

  function handleChangeParticipants(nextParticipants) {
    setDuplicateError(getIsDuplicate(nextParticipants))
  }

  // Only sets: the select empties its input after a refused pick and reports that too
  function handleValidateInput(input) {
    if (
      getIsAppointmentFormParticipantInputDuplicate({
        input,
        participants: [...organizerChips, ...participants],
      })
    ) {
      setDuplicateError(true)
    }
  }

  return (
    <DragDropProvider>
      <FormikField
        isDropDisabled
        Component={EmailRecipientsField}
        FilterButton={null}
        Tag={AppointmentFormModalParticipantTag}
        fieldComponentProps={{
          label: `${t('Appointment.FormParticipantsLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        getNextValue={getNextParticipants}
        lockedValues={organizerChips}
        name={APPOINTMENT_FORM_FIELD_NAME.participants}
        placeholder={t('Appointment.FormParticipantsPlaceholderKey')}
        onChange={handleChangeParticipants}
        onValidate={handleValidateInput}
      />
    </DragDropProvider>
  )
}

export default AppointmentFormModalParticipantsField
